<!--Footer Menu items-->
<div class="flex flex-wrap items-center justify-center text-[0.7em] text-white">
    <!-- <div class="flex-none m-1" *ngIf="!isTrackAppointmentPage()">
        <a routerLink="/track-appointment"> Track Appointment</a> |
    </div> -->
    <div class="flex-none m-1" *ngIf="isTrackAppointmentPage()">
        <a routerLink="/"> Home</a> |
    </div>
    <div class="flex-initial m-1">
        <a routerLink="/privacy-policy" target="_blank">Privacy Policy</a> |
    </div>
    <div class="flex-initial m-1">
        <a routerLink="/refund-policy" target="_blank">Refund Policy</a> |
    </div>
    <div class="flex-initial m-1">
        <a routerLink="/terms-conditions" target="_blank">Terms & Conditions</a>
    </div>
</div>
<!--End Footer Menu items-->